import { Button } from '@/components/ui/Button';
import { Footer } from '@/pages/public/landing/components/Footer';
import { Header } from '@/pages/public/landing/components/Header';
import { useNavigate } from 'react-router-dom';
import BrainIcon from '@/assets/icons/brain-icon.svg';
import { Helmet } from 'react-helmet-async';

const NotFound = () => {
	const navigate = useNavigate();

	const handleGoHome = () => {
		navigate('/');
	};

	return (
		<div className="flex min-h-screen flex-col bg-white">
			<Helmet>
				<title>Página não encontrada | Plumaa</title>
				<meta name="robots" content="noindex" />

				<meta property="og:type" content="website" />
				<meta
					property="og:title"
					content="Página não encontrada | Plumaa"
				/>
				<meta
					property="og:description"
					content="Encontre psicólogos e psiquiatras qualificados. Agende online."
				/>

				<meta
					property="og:image"
					content="https://res.cloudinary.com/dd5pbp2tb/image/upload/v1765924080/Banner_rxsb8s.png"
				/>
				<meta
					property="og:image:secure_url"
					content="https://res.cloudinary.com/dd5pbp2tb/image/upload/v1765924080/Banner_rxsb8s.png"
				/>

				<meta property="og:image:type" content="image/png" />
				<meta property="og:image:width" content="1200" />
				<meta property="og:image:height" content="630" />
			</Helmet>
			<Header />
			<main className="flex flex-1 flex-col items-center justify-center px-4 text-center">
				<div className="w-full max-w-md space-y-6">
					<img
						src={BrainIcon}
						alt="Ícone de Cérebro"
						className="mx-auto h-20 w-20 text-blue-500"
					/>
					<div className="space-y-2">
						<h1 className="text-3xl font-bold text-gray-900">
							Página Não Encontrada
						</h1>
						<p className="text-gray-500">
							Oops! Parece que esta página se perdeu nos
							corredores da mente.
						</p>
					</div>
					<Button
						text="Voltar à página inicial"
						onClick={handleGoHome}
						className="w-full md:mx-auto md:w-auto"
					/>
				</div>
			</main>
			<Footer />
		</div>
	);
};

export { NotFound };
